import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { paperCardSx } from './ConnectionsLayout'

type Props = {
  message: string
}

export function WidgetConnectionsError({ message }: Props) {
  return (
    <Paper sx={paperCardSx}>
      <Typography color="error">Failed to load widget: {message}</Typography>
    </Paper>
  )
}
